import API from "./API";
import axios from "axios";

const Rewards = {

    async getAll(){
        const url = API.url('/rewards');
        return await axios.get(url);
    },

    async getTypes(){
        const url = API.url('/rewards/types');
        return await axios.get(url);
    },

    async get(id){
        const url = API.url('/rewards/' + id);
        return await axios.get(url);
    },

    async post(data){
        const url = API.url('/rewards');
        return await axios.post(url, data);
    },

    async postPicture(id, file){
        const url = API.url(`/rewards/${id}/picture`);
        const data = new FormData();
        data.append('file', file);
        return await axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
    },

    async put(data){
        const url = API.url('/rewards/' + data.id);
        return await axios.put(url, data);
    },

    async delete(id){
        const url = API.url('/rewards/' + id);
        return await axios.delete(url);
    },

    async getQuintessenceCode(indentId){
        const url = API.url('/rewards/quintessence/code?indent=' + indentId);
        return await axios.get(url);
    }

}

export default Rewards;